import { twMerge } from "#lib/twMergeConfig"

export function LoadingSpinner({ className }: { className?: string }) {
  return (
    <div className={twMerge("classic-loading-spinner aspect-square h-auto w-full [--thickness:4px]", className)}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  )
}
